import React from 'react';

import { simpleColumn } from '../utils/column-helpers';
import BrandLink from './BrandLink';

export const nameLink = {
  Header: 'Name',
  accessor: 'name',
  width: 250,
  Cell: row => <BrandLink model={row.original} />,
};

export const name = simpleColumn('Name', 'name', 250);
export const code = simpleColumn('Code', 'code', 60);
export const family = simpleColumn('Family', 'family', 100);
export const shopStatus = simpleColumn('Status', 'shopStatus', 100);
export const cluster = simpleColumn('Cluster', 'cluster', 100);

export const listColumns = [nameLink, code, family, shopStatus, cluster];
export const selectColumns = [name, code, family, shopStatus, cluster];
